// 事件分析功能service
import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';

// 事件详情 表格
export const getEventRecordList: (data: any) => Promise<any> = (data) => {
    const options = {
        url: '/api/v1/dashboard/event_analysis/event_record_list',
        method: 'post',
        data: data,
    }
    return dashboardRequest(options)
};

// 保存事件
export const saveEventRecord: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v1/dashboard/event_analysis/save_event_record',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

// 获取事件类型
export const getEventTypeList: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v1/dashboard/event_analysis/event_type_list',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

const DEFAULT_DATE_EVENT_LIST_URL =
  '/api/v1/dashboard/event_analysis/date_event_list';

// Overview 日期事件列表（时间趋势图）；url 可覆盖，供 EventService 等配置化页面使用
export const getDateEventTypeList: (
  data: any,
  url?: string,
) => Promise<any> = (data, url) => {
  const options = {
    url: url || DEFAULT_DATE_EVENT_LIST_URL,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Realtime 事件列表
export const getRealtimeEventTypeList: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v1/dashboard/event_analysis/realtime/date_event_list',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

// 校验新增的Event Type Title是否存在
export const validateEventTypeTitle: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v1/dashboard/event_analysis/event_title/check',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

// 删除事件记录
export const deleteEventItem: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v1/dashboard/event_analysis/delete_event_record',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

// 校验新增的Event Type Title是否存在
export const getEventList: (data: any) => Promise<any> = (data) => {
  const options = {
      url: '/api/v1/dashboard/pc/event_analysis_v2/select_event',
      method: 'post',
      data: data,
  }
  return dashboardRequest(options)
};

